import { ref, type Ref } from "vue";

/**
 * Shared open-state for the channel ANNOUNCEMENTS modal (new channel layout).
 *
 * The modal itself is hosted inside channel.vue (the page mounted via
 * <RouterView />), but its open triggers live in TWO places that do NOT share a
 * component tree:
 *   1. The HOW-IT-WORKS card (<ChannelBenefitsBar>) rendered inside channel.vue.
 *   2. The ANNOUNCEMENTS tab in <ChannelTopBar>, which is mounted by the shell
 *      (channel-layout-v2.vue) OUTSIDE channel.vue.
 *
 * A module-scoped singleton ref is the lightest cross-tree channel for this
 * boolean intent — there is no per-instance state and nothing to put in a Pinia
 * store (mirrors the Vue state rules: component-local UI state that happens to
 * be shared across two sibling subtrees stays a singleton composable, not a
 * store). Both consumers import this composable; the modal v-model-binds
 * `isOpen` and the triggers call `open()`.
 */
const isOpen = ref(false);

export function useAnnouncementsModal(): {
  isOpen: Ref<boolean>;
  open: () => void;
  close: () => void;
} {
  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return { isOpen, open, close };
}
